<script>
    // Import lib
    import { fade } from 'svelte/transition';
    import { changeLocale } from '../script/locale.js';

    // Import settings
    export let isFixed;
    export let logo;
    export let menu;
    export let languages;

    // - Vars - //

    // subMenu state (Used only on mobile)
    let subMenu = {
        "visible": false,
    }

    // - Functions - //

    // Active and deactivate subMenu (Used only on mobile)
    function toggleSubMenu() {
        subMenu.visible = !subMenu.visible;
    }

    // Set topBar mode: fixed or not
    function getIsFixed() {
        if (isFixed == 'true') {
            return 'fixed';
        } else {
            return '';
        }
    }
</script>

<div class="bg-white inset-x-0 top-0 {getIsFixed()}">
    <div class="bg-white container mx-auto p-3">
        <div class="flex">
            <button on:click="{toggleSubMenu}" class="md:hidden flex-none border-0 py-1">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
                </svg>
            </button>
            <a href="/#" class="flex-1 text-center md:text-left text-zinc-900 hover:text-zinc-500 uppercase font-bold text-2xl">{logo}</a>
            <div class="hidden md:flex">
                {#each menu as item}
                    <a href="{item.link}" class="flex-auto text-zinc-900 hover:text-zinc-500 px-3 py-1 ">{item.name}</a>
                {/each}
            </div>
            <div class="hidden md:flex text-zinc-900 px-3 py-1">|</div>
            <div class="flex">
                {#each languages as item}
                    {#if item.locale != localStorage.getItem('locale') }
                        <button on:click="{changeLocale(item.locale)}" class=" flex border-0 p-1 hover:opacity-70">{item.icon}</button>
                    {/if}
                {/each}
            </div>
        </div>
        {#if subMenu.visible}
            <div in:fade={{ delay: 100 }} out:fade={{ delay:100 }} class="container mx-auto fiexed flex py-1 md:hidden">
                {#each menu as item}
                    <a on:click="{toggleSubMenu}" href="{item.link}" class="flex-auto text-center text-zinc-900 p-1">{item.name}</a>
                {/each}
            </div>
        {/if}
    </div>
</div>

